export const SERVICE_CODE = 'TRAINING_ATTENDANCES' + '_SERVICE';
